<template>
  <router-view />
</template>

<script setup>
// Nada más necesario aquí
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
</style>